// If screen is above 1024px - enable body scroll
window.addEventListener('resize', function () {
  if (window.matchMedia('(min-width: 1024px)').matches) {
    body.classList.remove('noscroll');
  }
});

// If user clicks hamburger button - animate icon & display mobile overlay
const hamburger = document.getElementById('hamburger');
const mobileOverlay = document.querySelector('.mobile-overlay');
const body = document.getElementsByTagName('BODY')[0];

hamburger.addEventListener('click', () => {
  hamburger.classList.toggle('animate');
  mobileOverlay.classList.toggle('open');
  // Disable body scroll on mobile view
  body.classList.toggle('noscroll');
});

// If user clicks mobile accordion - show/hide
const acc = document.getElementsByClassName('mobile-accordion');
const panel = document.getElementsByClassName('mobile-panel');

for (var i = 0; i < acc.length; i++) {
  acc[i].onclick = function () {
    var setClasses = !this.classList.contains('active');
    setClass(acc, 'active', 'remove');
    setClass(panel, 'show', 'remove');

    if (setClasses) {
      this.classList.toggle('active');
      this.nextElementSibling.classList.toggle('show');
    }
  };
}
function setClass(els, className, fnName) {
  for (var i = 0; i < els.length; i++) {
    els[i].classList[fnName](className);
  }
}

// Highlight active nav item
const homeownersLink = document.getElementById('homeowners-link');
const professionalsLink = document.getElementById('professionals-link');
const solutionsLink = document.getElementById('solutions-link');
const productsLink = document.getElementById('products-link');
const worksLink = document.getElementById('works-link');
const supportLink = document.getElementById('support-link');
const currentPath = window.location.pathname;

switch (currentPath) {
  case '/pages/homeowners':
    homeownersLink.classList.add('active-link');
    break;
  case '/pages/builders':
  case '/pages/integrators':
    professionalsLink.classList.add('active-link');
    break;
  case '/pages/ventilation':
  case '/pages/lighting':
  case '/pages/energy-management':
    solutionsLink.classList.add('active-link');
    break;
  case '/collections/bundles':
  case '/collections/outlets-switches':
  case '/collections/inserts':
  case '/collections/all-products':
    productsLink.classList.add('active-link');
    break;
  case '/pages/integrations':
    worksLink.classList.add('active-link');
    break;
  case 'hc/en-us':
    supportLink.classList.add('active-link');
    break;
}

// If user clicks outside of search bar - close it
const searchButton = document.querySelector('details .modal__toggle-open.icon.icon-search');
const overlay = document.querySelector('.header__search details .modal-overlay');
const details = document.querySelector('.header__search details');

searchButton.addEventListener('click', () => {
  overlay.addEventListener('click', () => {
    details.removeAttribute('open');
  });
});

// Only display VacantView button on VacantView page & login screen
document.addEventListener("DOMContentLoaded", function() {
  if (window.location.pathname === "/pages/vacantview") {
    document.getElementById("vacantview-dashboard").style.display = "list-item";
    document.getElementById("vv-dashboard-mobile").style.display = "flex";
    let vacantPage = document.getElementById("MainContent");
    vacantPage.classList.add("add-margin");
  }
  if (window.location.pathname === "/account/login") {
    document.getElementById("vacantview-dashboard").style.display = "list-item";
    document.getElementById("vv-dashboard-mobile").style.display = "flex";
  }
});
